import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_current_status } from "../../../../utils";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import ClipLoader from "react-spinners/ClipLoader";
import { formatPrice } from "../../../../utils/formatPrice";
import useDebounce from "./AdWorkShop/hooks/useDebounce";
import { order_actions } from "../../../../redux-store";

const Orders = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();

  const { user } = useSelector((state) => state.auth);
  const { orders, totalPages } = useSelector((state) => state.order);
  const loading = useSelector((state) => state.global.loading);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search, 500);

  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const getOrders = (page = 1, search = "") => {
    dispatch(
      order_actions.fetch_orders({
        search,
        page,
        limit: 5,
        customer: user?._id,
      })
    );
  };

  useEffect(() => {
    getOrders(page, debouncedSearch);
  }, [page, debouncedSearch]);

  useEffect(() => {
    if (user) {
      if (!pathname.includes(user?.user?.role)) {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user, pathname, history]);

  return (
    <>
      <Helmet>
        <title>eksplode! | My Orders</title>
      </Helmet>
      <div className="dashboard">
        <div className="page-title">
          <h2>My Orders</h2>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <input
                className="form-control mb-0"
                type="text"
                name="name"
                placeholder="Search orders"
                value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ClipLoader color={"#000000"} loading={loading} size={60} />
            </div>
          </div>
        ) : (
          <>
            {orders?.length > 0 ? (
              orders?.map((order) => {
                const curr_status = get_current_status(order);
                return (
                  <div className="box-account box-info mt-3" key={order?._id}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="box">
                          <div className="box-title">
                            <h3>
                              <span>
                                Order ID &mdash; <b>{order?.order_track_id}</b>
                              </span>
                              <br />
                              <small className="text-muted">
                                Current Status &mdash;{" "}
                                {curr_status?.status_title}
                              </small>
                              <br />
                              <small className="text-muted">
                                {new Date(
                                  curr_status?.status_date
                                ).toDateString()}
                              </small>
                            </h3>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                            >
                              {formatPrice(
                                order?.total_price +
                                order?.billing_details?.delivery_charges + order?.total_sales_tax
                              )}
                            </a>
                          </div>
                          <div className="box-content">
                            {order?.items.map((item) => (
                              <h6
                                className="mb-2 d-flex justify-content-between"
                                key={item._id}
                              >
                                {item?.product?.product_name}
                                <small className="text-muted">
                                  Product Price &mdash;{" "}
                                  {formatPrice(item?.product?.product_price)}
                                  <br />
                                  Quantity &mdash; {item?.quantity}{" "}
                                </small>
                              </h6>
                            ))}
                            <h6>
                              <Link to={`/order/${order?._id}`}>
                                View Order
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                );
              })
            ) : (
              <div className="box-account box-info mt-3">
                <div className="my-5 row justify-content-center">
                  <h3>No Orders Available</h3>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-center mt-5">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={page - 1}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Orders;
